export const environment = {
    production: false,
    msalConfig: {
        auth: {
            clientId: '18c7f9d8-242b-428f-b091-ffff45acc194',
            authority: 'https://login.microsoftonline.com/5be674aa-b67b-4ef9-8c22-f3666fb2590d'
        }
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    mapBox: {
        accessToken: 'pk.eyJ1IjoiamhhcnJvbGQiLCJhIjoiY2tzcXBmMjR5MDF6czJvbGJ2ZDVxZ2RodCJ9.fIIclnE_rIT93Z7yq5--3A'
    },
    landmark_API_URL: 'https://landmarkapi-beta-hcbzcme2dha6ckh5.westus-01.azurewebsites.net/api',
    frontEnd_URL: 'https://beta.lexar.app',
    sentry: {
        dsn: 'https://2a5aa32d5af11da7f74846170908d566@o4506385370775552.ingest.us.sentry.io/4506385535860736',
        tracesSampleRate: '1.0'
    },
    payload_url: 'admin.lexarhub.app'
};
